/* eslint-disable no-restricted-globals */
/* eslint-disable no-alert */
import Router from 'next/router';
import { useEffect } from 'react';
import { useTranslation } from '@locales/useTranslation.hook';

export function useWarnIfUnsavedChanges(unsavedChanges: boolean, onNavigationCancel?: () => void) {
  const { t } = useTranslation(['common']);
  const message = t('common.confirm-navigation-without-save');

  useEffect(() => {
    const routeChangeStart = (url: string) => {
      if (Router.asPath !== url && unsavedChanges && !confirm(message)) {
        Router.events.emit('routeChangeError');
        Router.replace(Router, Router.asPath);
        if (onNavigationCancel) onNavigationCancel();
        throw new Error('Abort route change. Please ignore this error.');
      }
    };

    Router.events.on('routeChangeStart', routeChangeStart);

    return () => {
      Router.events.off('routeChangeStart', routeChangeStart);
    };
  }, [unsavedChanges]);
}
